import {useCallback, useState} from 'react';
import {ScrollView, View} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';
import {Button} from 'react-native-paper';
import {Text} from '../../Components';
import {PageContainer} from '../../Containers';
import {useTheme} from '../../Hooks';
import {RootCustomizeScreenProps} from '../../Typings/NavigationTypes';
import {getCopy} from '../../Utils/I18n';
import {TelemetryConfig, loadTelemetryConfig} from '../../Utils/Telemetry';
import getStyles from './ADAPT-MH.styles';

type Props = RootCustomizeScreenProps;

const Customize: React.FC<Props> = ({navigation}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const copy = getCopy('en');
  const [telemetryConfig, setTelemetryConfig] = useState<TelemetryConfig | null>(null);

  useFocusEffect(
    useCallback(() => {
      loadTelemetryConfig().then(setTelemetryConfig);
    }, []),
  );

  const sharingStatus = telemetryConfig?.enabled
    ? copy.dataSharing.statusOn
        .replace('{site}', telemetryConfig.siteCode)
        .replace('{date}', new Date(telemetryConfig.consentedAt).toLocaleDateString())
    : copy.dataSharing.statusOff;

  return (
    <PageContainer withSafeArea withPadding>
      <ScrollView contentContainerStyle={styles.scrollContent}>
        <View style={styles.hero}>
          <Text
            fontSize={30}
            lineHeight={37}
            weight="black"
            accessibilityRole="header"
            style={styles.title}
          >
            {copy.clinicianLanding.customize}
          </Text>
          <Text fontSize={16} lineHeight={24} style={styles.subtitle}>
            {copy.dataSharing.customizeSubtitle}
          </Text>
        </View>

        <View style={styles.card}>
          <Text weight="bold" fontSize={17} style={styles.strongBody}>
            {copy.dataSharing.title}
          </Text>
          <Text style={styles.listItem}>{sharingStatus}</Text>
          <Button
            mode="contained"
            onPress={() => navigation.navigate('DataSharing', {})}
            style={styles.button}
            buttonColor={theme.colors.primary}
            textColor={theme.colors.textContrast}
          >
            {copy.dataSharing.openButton}
          </Button>
        </View>

        <View style={styles.softCard}>
          <Text weight="bold" fontSize={17} style={styles.strongBody}>
            Content to be added later.
          </Text>
          <Text style={styles.listItem}>
            Further site-specific configuration is reserved for the ADAPT-MH clinical team to define
            in a later build.
          </Text>
        </View>
      </ScrollView>
    </PageContainer>
  );
};

export default Customize;
